import React, { useState, useEffect, useRef } from 'react';
import { nativePrintTarget, resolvePrinterForElectron } from '../../utils/printTarget';
import { StyleSheet, View } from 'react-native';
import { formatPrice } from '../../utils/formatPrice';
import { Order, Table, ProstayGuestDto, Customer } from '../../interfaces';
import Select from 'react-select';
import { format } from 'date-fns';
import './EditOrderPopup.css';
import EmailReceipt from './EmailReceipt';
import Spinner from '../Spinner';
import { useAuth } from '../../AuthContext';
import SuccessNotification from '../notifications/SuccessNotification';
import ErrorNotification from '../notifications/ErrorNotification';


const formatDateForReceipt = (date: Date): string => {
    return new Date(date).toLocaleString('en-US', {
        weekday: 'short',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
    });
};

interface CustomerSearchResult {
    type: 'prostay' | 'tableview';
    /** Set for TableView customers only — Prostay guests are not customer records. */
    customerId?: string;
    firstName: string;
    lastName: string;
    email?: string;
    roomNumber?: string;
    reservationNumber?: string;
}
interface EditOrderPopupProps {
    order: Order;
    onClose: () => void;
    onSave: (updatedOrder: Order) => void;
    isOpen: boolean;
    tables: Table[] | undefined;
    onShowVoidConfirmation: () => void;
    onShowVoidReason: () => void;
    receiptPrinterId?: string;
}

interface TableOption {
    value: string;
    label: string;
}

const EditOrderPopup: React.FC<EditOrderPopupProps> = ({ isOpen, order, onClose, onSave, tables, onShowVoidConfirmation, onShowVoidReason, receiptPrinterId }) => {
    const { hasPerm } = useAuth();
    const can = (key: string) => !hasPerm || hasPerm(key);
    const [updatedOrder, setUpdatedOrder] = useState(order);
    const [isInEditMode, setIsInEditMode] = useState(false);
    const [tableOptions, setTableOptions] = useState<TableOption[]>([]);
    const [emailReceiptOpen, setEmailReceiptOpen] = useState(false);
    const [emailSplitInfo, setEmailSplitInfo] = useState<{ seatId: string; splitIndex: number; guestName: string; roomNumber: string } | undefined>(undefined);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [successTitle, setSuccessTitle] = useState('');
    const [errorTitle, setErrorTitle] = useState('');
    const [errorContent, setErrorContent] = useState('');
    const [successContent, setSuccessContent] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [customerSearchResults, setCustomerSearchResults] = useState<CustomerSearchResult[]>([]);
    const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
    const [searchingCustomers, setSearchingCustomers] = useState(false);
    const customerSearchRef = useRef<HTMLDivElement>(null);
    const [previewHtml, setPreviewHtml] = useState<string | null>(null);
    const [previewSplitContext, setPreviewSplitContext] = useState<{ payment: any; splitIndex: number } | null>(null);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);

        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    useEffect(() => {
        console.log("updated order:")
        console.log(order)
        if (tables) {
            const options = tables.map((table) => ({
                value: table.id,
                label: table.tableNo,
            }));

            if (order.mergedTablesIds && order.mergedTablesNames && order.mergedTablesIds.length > 0) {
                options.push({
                    value: order.mergedTablesIds.join(','),
                    label: order.mergedTablesNames.join(','),
                });
            }
            setTableOptions(options);
        }
    }, [tables, order.mergedTablesIds, order.mergedTablesNames, order]);

    // Click outside handler for customer search dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (customerSearchRef.current && !customerSearchRef.current.contains(event.target as Node)) {
                setShowCustomerDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    // async function previewReceipt() {
    //     setIsLoading(true);
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/preview-order`, {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify({ 
    //                 order: order,
    //                 formattedDate: formatDateForReceipt(order.date)
    //             }),
    //             credentials: 'include',
    //         });
    //         if (!response.ok) throw new Error(`Failed: ${response.status}`);
    //         const html = await response.text();
    //         setPreviewHtml(html);
    //     } catch (error) {
    //         setErrorTitle('Error');
    //         setErrorContent('Error loading preview: ' + (error.message || 'Unknown error'));
    //         setShowError(true);
    //         setTimeout(() => setShowError(false), 5000);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    const searchCustomers = async (searchValue: string) => {
        if (!searchValue) {
            setCustomerSearchResults([]);
            setShowCustomerDropdown(false);
            return;
        }

        setSearchingCustomers(true);
        setShowCustomerDropdown(true);
        const combinedResults: CustomerSearchResult[] = [];

        // Fetch Prostay guests
        try {
            const prostayPayload = {
                currentPage: 1,
                searchTerm: searchValue,
                pageSize: 100,
                filterDuplicatesByEmail: false
            };

            const prostayResponse = await fetch(`${process.env.REACT_APP_API_URL}/Prostay/search-prostay-guest`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(prostayPayload),
                credentials: 'include',
            });

            if (prostayResponse.ok) {
                const prostayData = await prostayResponse.json();
                const prostayResults: CustomerSearchResult[] = (prostayData.data || []).map((guest: ProstayGuestDto) => ({
                    type: 'prostay' as const,
                    firstName: guest.firstName || '',
                    lastName: guest.lastName || '',
                    email: guest.email,
                    roomNumber: guest.roomNumber,
                    reservationNumber: guest.reservationNumber,
                }));
                combinedResults.push(...prostayResults);
            }
        } catch (error) {
            console.error('Error fetching Prostay guests:', error);
        }

        // Fetch TableView customers
        try {
            const customerPayload = {
                currentPage: 1,
                searchTerm: searchValue,
                pageSize: 100,
            };

            const customerResponse = await fetch(`${process.env.REACT_APP_API_URL}/Customer/filter`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(customerPayload),
                credentials: 'include',
            });

            if (customerResponse.ok) {
                const customerData = await customerResponse.json();
                const customerResults: CustomerSearchResult[] = (customerData.data || []).map((customer: Customer) => ({
                    type: 'tableview' as const,
                    customerId: customer.id,
                    firstName: customer.firstName || '',
                    lastName: customer.lastName || '',
                    email: customer.email,
                }));
                combinedResults.push(...customerResults);
            }
        } catch (error) {
            console.error('Error fetching TableView customers:', error);
        }

        setCustomerSearchResults(combinedResults);
        setSearchingCustomers(false);
    };

    const handleCustomerSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setUpdatedOrder(prev => ({
            ...prev,
            customerName: value
        }));
        searchCustomers(value);
    };

    const handleSelectCustomer = (result: CustomerSearchResult) => {
        const fullName = `${result.firstName} ${result.lastName}`.trim();
        setUpdatedOrder(prev => ({
            ...prev,
            customerName: fullName,
            customerEmail: result.email || prev.customerEmail,
            customerId: result.customerId || prev.customerId,
            roomNumber: result.roomNumber || prev.roomNumber,
            reservationNumber: result.reservationNumber || prev.reservationNumber,
        }));
        setShowCustomerDropdown(false);
    };

    const statusOptions = [
        { value: 0, label: 'Submit' },
        { value: 1, label: 'In Progress' },
        { value: 2, label: 'Served' },
        { value: 3, label: 'Closed/Done' },
    ];

    const handleSave = () => {
        onSave(updatedOrder);
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setUpdatedOrder(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleTableChange = (selectedOption: { value: string, label: string } | null) => {
        if (selectedOption?.value.includes(",")) { //this means we selected the merged tables
            const ids = selectedOption.value.split(",");
            const names = selectedOption.label.split(",");

            setUpdatedOrder(prev => ({
                ...prev,
                tableId: ids ? ids[0] : '',
                tableName: '',
                mergedTablesIds: ids,
                mergedTablesNames: names
            }));
        }
        else {
            setUpdatedOrder(prev => ({
                ...prev,
                tableId: selectedOption ? selectedOption.value : '',
                tableName: selectedOption ? selectedOption.label : '',
                mergedTablesIds: null,
                mergedTablesNames: null
            }));
        }
    };

    const handleStatusChange = (selectedOption: { value: number, label: string } | null) => {
        setUpdatedOrder(prev => ({
            ...prev,
            status: selectedOption ? selectedOption.value : 0,
        }));
    };

    const formatDate = (date: Date) => {
        const day = format(date, 'd');
        const daySuffix = getDaySuffix(day);
        const formattedDate = format(date, `d'${daySuffix}' yyyy 'at' h:mmaaa`);
        return formattedDate;
    };

    const getDaySuffix = (day: string) => {
        if (day === '1' || day === '21' || day === '31') return 'st';
        if (day === '2' || day === '22') return 'nd';
        if (day === '3' || day === '23') return 'rd';
        return 'th';
    };

    const handleVoidClick = () => {
        if (order.status == 1) {
            onShowVoidConfirmation();
        }
        else {
            onShowVoidReason();
        }
    }

    const styles = StyleSheet.create({
        drawer: {
            top: 0,
            right: 0,
            width: windowSize.width > 900 ? windowSize.width * 0.47 : windowSize.width * 0.9,
            height: windowSize.height,
            backgroundColor: 'white',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            elevation: 5,
            zIndex: 1002,
            position: 'fixed',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        openDrawer: {
            right: 0,
        },
        closedDrawer: {
            right: -(windowSize.width > 900 ? windowSize.width * 0.47 : windowSize.width * 0.9),
        },
    });

    const hasSplitPayments = order.payments && order.payments.length > 1 && order.payments.some((p: any) => p.seatId);

    async function fetchSplitReceiptHtml(payment: any, splitIndex: number): Promise<string> {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/generate-split-receipt`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                order: order,
                seatId: payment.seatId,
                splitIndex: splitIndex,
                guestName: payment.guestName || '',
                roomNumber: payment.roomNumber || '',
                formattedDate: formatDateForReceipt(new Date()),
            }),
            credentials: 'include',
        });
        if (!response.ok) throw new Error(`Failed to generate split receipt: ${response.status}`);
        // Response is a blob URL — fetch the actual HTML
        const blobUrl = await response.text();
        const htmlRes = await fetch(blobUrl);
        return await htmlRes.text();
    }

    async function previewSplitReceipt(payment: any, splitIndex: number) {
        setIsLoading(true);
        try {
            const html = await fetchSplitReceiptHtml(payment, splitIndex);
            setPreviewSplitContext({ payment, splitIndex });
            setPreviewHtml(html);
        } catch (error: any) {
            setErrorTitle('Error');
            setErrorContent('Error loading preview: ' + (error.message || "Unknown error"));
            setShowError(true);
            setTimeout(() => setShowError(false), 5000);
        } finally {
            setIsLoading(false);
        }
    }

    async function printSplitReceiptFromPreview() {
        if (!previewSplitContext) return;
        setIsLoading(true);
        try {
            let printer = order.printer;
            if (receiptPrinterId) {
                const printerRes = await fetch(`${process.env.REACT_APP_API_URL}/Printer/${receiptPrinterId}`, { method: 'GET', credentials: 'include' });
                if (printerRes.ok) printer = await printerRes.json();
            }
            if (!printer) throw new Error("No receipt printer configured for this floor");

            const response = await fetch(`${process.env.REACT_APP_API_URL}/Order/generate-split-receipt`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    order: order,
                    seatId: previewSplitContext.payment.seatId,
                    splitIndex: previewSplitContext.splitIndex,
                    guestName: previewSplitContext.payment.guestName || '',
                    roomNumber: previewSplitContext.payment.roomNumber || '',
                    formattedDate: formatDateForReceipt(new Date()),
                }),
                credentials: 'include',
            });
            if (!response.ok) throw new Error(`Failed to generate split receipt: ${response.status}`);
            const receiptHtmlUrl = await response.text();
            if ((window as any).electronAPI?.printThermalReceipt) {
                const result = await window.electronAPI.printThermalReceipt(receiptHtmlUrl, { ...order, printer: resolvePrinterForElectron(printer) });
                if (!result || !result.success) throw new Error(result?.error || "Unknown error");
            } else {
                // On tablet: use native WebView to render and print via TCP
                const { Capacitor } = await import('@capacitor/core');
                if (Capacitor.isNativePlatform()) {
                    const { ThermalPrinter } = (Capacitor as any).Plugins;
                    if (!ThermalPrinter) throw new Error('ThermalPrinter plugin not available');
                    await ThermalPrinter.printHtml({
                        htmlUrl: receiptHtmlUrl,
                        ...nativePrintTarget(printer),
                        port: printer?.port || 9100,
                        ticketWidthMm: printer?.ticketWidth || 80,
                        autoCutter: printer?.hasAutoCutter ?? true,
                        printerType: printer?.type === 'Star Micronics' ? 'STAR' : 'EPSON',
                    });
                } else {
                    throw new Error('Printing is only available on desktop or tablet app');
                }
            }
            setPreviewHtml(null);
            setPreviewSplitContext(null);
        } catch (error: any) {
            setErrorTitle('Error');
            setErrorContent('Error printing: ' + (error.message || "Unknown error"));
            setShowError(true);
            setTimeout(() => setShowError(false), 5000);
        } finally {
            setIsLoading(false);
        }
    }

    async function printReceipt() {
        setIsLoading(true);

        try {
            // Fetch the receipt printer details
            let printer = order.printer;
            if (receiptPrinterId) {
                const printerRes = await fetch(`${process.env.REACT_APP_API_URL}/Printer/${receiptPrinterId}`, {
                    method: 'GET',
                    credentials: 'include',
                });
                if (printerRes.ok) {
                    printer = await printerRes.json();
                }
            }

            if (!printer) {
                throw new Error("No receipt printer configured for this floor");
            }

            let response: Response | null = null;
            try {
                response = await fetch(`${process.env.REACT_APP_API_URL}/Order/generate-order`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ order: order, formattedDate: formatDateForReceipt(new Date()) }),
                    credentials: 'include',
                });
                if (!response.ok) response = null;
            } catch { response = null; }

            // Offline fallback: generate receipt locally
            if (!response) {
                const { default: ReceiptService } = await import('../../services/ReceiptService');
                const localHtml = await ReceiptService.generateReceiptHtml(order, formatDateForReceipt(new Date()));
                // For Electron: save to temp blob URL; for Capacitor: use htmlContent
                const { Capacitor } = await import('@capacitor/core');
                if ((window as any).electronAPI?.printThermalReceipt) {
                    const blob = new Blob([localHtml], { type: 'text/html' });
                    const blobUrl = URL.createObjectURL(blob);
                    const result = await window.electronAPI.printThermalReceipt(blobUrl, { ...order, printer: resolvePrinterForElectron(printer) });
                    URL.revokeObjectURL(blobUrl);
                    if (!result?.success) throw new Error(result?.error || 'Print failed');
                } else if (Capacitor.isNativePlatform()) {
                    const { ThermalPrinter } = (Capacitor as any).Plugins;
                    await ThermalPrinter.printHtml({ htmlContent: localHtml, ...nativePrintTarget(printer), port: printer?.port || 9100, ticketWidthMm: printer?.ticketWidth || 80, autoCutter: printer?.hasAutoCutter ?? true, printerType: printer?.type === 'Star Micronics' ? 'STAR' : 'EPSON' });
                }
                setIsLoading(false);
                return;
            }

            const receiptHtmlUrl = await response.text();

            if ((window as any).electronAPI?.printThermalReceipt) {
                const result = await window.electronAPI.printThermalReceipt(receiptHtmlUrl, {
                    ...order,
                    printer: resolvePrinterForElectron(printer),
                });

                if (!result || !result.success) {
                    throw new Error(result?.error || "Unknown error from Electron");
                }
            } else {
                // On tablet: use native WebView to render and print via TCP
                const { Capacitor } = await import('@capacitor/core');
                if (Capacitor.isNativePlatform()) {
                    const { ThermalPrinter } = (Capacitor as any).Plugins;
                    if (!ThermalPrinter) throw new Error('ThermalPrinter plugin not available');
                    await ThermalPrinter.printHtml({
                        htmlUrl: receiptHtmlUrl,
                        ...nativePrintTarget(printer),
                        port: printer?.port || 9100,
                        ticketWidthMm: printer?.ticketWidth || 80,
                        autoCutter: printer?.hasAutoCutter ?? true,
                        printerType: printer?.type === 'Star Micronics' ? 'STAR' : 'EPSON',
                    });
                } else {
                    throw new Error('Printing is only available on desktop or tablet app');
                }
            }

        } catch (error) {
            console.error("Error while printing:", error.message || error);

            setErrorTitle('Error');
            setErrorContent('Error while printing: ' + (error.message || "Unknown error"));
            setShowError(true);

            setTimeout(() => setShowError(false), 5000);
        } finally {
            setIsLoading(false);
        }
    }





    const handleReceiptEmailSent = () => {
        setEmailReceiptOpen(false);
        setSuccessTitle('Success');
        setSuccessContent('Receipt was sent successfully.');
        setShowSuccess(true);
        setTimeout(() => {
            setShowSuccess(false);
        }, 3000);
    }

    return (
        <View style={[styles.drawer, isOpen ? styles.openDrawer : styles.closedDrawer]}>
            <div className='edit-order-popup'>
                <div className='d-flex px-3 pt-3 justify-content-between'>
                    <h5>View/Edit Order</h5>
                    <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                        <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
                <hr />
                <div className='px-3 pb-3'>
                    <small>Depending on your user permissions, various options and details may be available or not.</small>
                    <div className='d-flex justify-content-between mt-4'>
                        <div className='col-7 d-flex align-items-center'>
                            <div className='col-4 d-flex align-items-center'>
                                <label>Order Number</label>
                            </div>
                            <div className='col-6 d-flex align-items-center'>
                                <p className='mb-0' style={{ fontSize: 12 }}>{updatedOrder.orderNumber || ''}</p>
                            </div>
                        </div>
                        <div className='col-5 d-flex align-items-center tables-selection'>
                            <div className='col-3 d-flex align-items-center'>
                                <label>Table</label>
                            </div>
                            <div className='col-9 d-flex align-items-center'>
                                {
                                    isInEditMode ?
                                        <Select
                                            value={tableOptions?.find(option => updatedOrder.mergedTablesIds && updatedOrder.mergedTablesIds.length > 0 ? option.value == updatedOrder.mergedTablesIds?.join(',') : option.value === updatedOrder.tableId)}
                                            onChange={handleTableChange}
                                            options={tableOptions}
                                            placeholder=""
                                            isClearable
                                        />
                                        :
                                        <Select
                                            value={tableOptions?.find(option => updatedOrder.mergedTablesIds && updatedOrder.mergedTablesIds.length > 0 ? option.value == updatedOrder.mergedTablesIds?.join(',') : option.value === updatedOrder.tableId)}
                                            onChange={handleTableChange}
                                            options={tableOptions}
                                            placeholder=""
                                            isClearable
                                            isDisabled={true}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mt-3'>
                        <div className='w-100 d-flex align-items-center'>
                            <div style={{ width: '120px', flexShrink: 0 }} className='d-flex align-items-center'>
                                <label>Customer Name</label>
                            </div>
                            <div className='flex-grow-1 d-flex align-items-center' style={{ position: 'relative' }} ref={customerSearchRef}>
                                {
                                    isInEditMode ?
                                        <>
                                            <input type='text' name="customerName"
                                                value={updatedOrder.customerName || ''}
                                                onChange={handleCustomerSearchChange}
                                                placeholder="Search customer..."
                                                autoComplete="off"
                                                style={{ width: '100%' }} />
                                            {showCustomerDropdown && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    right: 0,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #D0D5DD',
                                                    borderRadius: '8px',
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}>
                                                    {searchingCustomers ? (
                                                        <div style={{ padding: '10px', textAlign: 'center' }}>
                                                            <small>Searching...</small>
                                                        </div>
                                                    ) : customerSearchResults.length > 0 ? (
                                                        customerSearchResults.map((result, index) => (
                                                            <div
                                                                key={index}
                                                                onClick={() => handleSelectCustomer(result)}
                                                                style={{
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: index < customerSearchResults.length - 1 ? '1px solid #EAECF0' : 'none',
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                                            >
                                                                <div className='d-flex align-items-center gap-2'>
                                                                    <span style={{
                                                                        backgroundColor: result.type === 'prostay' ? '#E0E7FF' : '#D1FAE5',
                                                                        color: result.type === 'prostay' ? '#3730A3' : '#065F46',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '4px',
                                                                        fontSize: 10,
                                                                        fontWeight: 600
                                                                    }}>
                                                                        {result.type === 'prostay' ? 'Prostay' : 'TableView'}
                                                                    </span>
                                                                    <span style={{ fontWeight: 500, fontSize: 13 }}>{result.firstName} {result.lastName}</span>
                                                                    {result.email && <span style={{ fontSize: 11, color: '#6B7280' }}>{result.email}</span>}
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div style={{ padding: '10px', textAlign: 'center' }}>
                                                            <small style={{ color: '#6B7280' }}>No results found</small>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                        :
                                        <input type='text' name="customerName"
                                            value={updatedOrder.customerName || ''}
                                            onChange={handleInputChange} disabled
                                            style={{ width: '100%' }} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between mt-3'>
                        <div className='w-100 d-flex align-items-center'>
                            <div style={{ width: '120px', flexShrink: 0 }} className='d-flex align-items-center'>
                                <label>Order Amount</label>
                            </div>
                            <div className='flex-grow-1 d-flex align-items-center'>
                                {
                                    isInEditMode ?
                                        <input type='text' name="total"
                                            value={updatedOrder.total || ''}
                                            onChange={handleInputChange}
                                            style={{ width: '100%' }} />
                                        :
                                        <input type='text' name="total"
                                            value={updatedOrder.total || ''}
                                            onChange={handleInputChange} disabled
                                            style={{ width: '100%' }} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between mt-3'>
                        <div className='w-100 d-flex align-items-center'>
                            <div style={{ width: '120px', flexShrink: 0 }} className='d-flex align-items-center'>
                                <label>Order Status</label>
                            </div>
                            <div className='flex-grow-1 d-flex align-items-center'>
                                {
                                    isInEditMode ?
                                        <Select
                                            value={statusOptions.find(option => option.value === updatedOrder.status)}
                                            onChange={handleStatusChange}
                                            options={statusOptions}
                                            placeholder=""
                                            isClearable
                                            styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                                        />
                                        :
                                        <Select
                                            value={statusOptions.find(option => option.value === updatedOrder.status)}
                                            onChange={handleStatusChange}
                                            options={statusOptions}
                                            placeholder=""
                                            isClearable
                                            isDisabled={true}
                                            styles={{ container: (base) => ({ ...base, width: '100%' }) }}
                                        />
                                }
                            </div>
                        </div>
                    </div>
                    <small className='mt-3 d-flex'>
                        Order Created on {formatDate(updatedOrder.date)}
                    </small>
                    {
                        updatedOrder.orderPaidOn &&
                        <small className='mt-1 d-flex'>
                            Order Paid on {formatDate(updatedOrder.orderPaidOn)}
                        </small>
                    }
                    {
                        updatedOrder.createdBy &&
                        <small className='mt-1 d-flex'>
                            Order Created by Waiter {updatedOrder.waiter}
                        </small>
                    }
                    {
                        updatedOrder.closedBy && statusOptions.find(opt => opt.value === updatedOrder.status)?.label === 'Done' &&
                        <small className='mt-1 d-flex'>
                            Order Closed by Waiter {updatedOrder.closedBy}
                        </small>
                    }
                    {
                        (updatedOrder.tipAmount != null && updatedOrder.tipAmount > 0) &&
                        <small className='mt-1 d-flex' style={{ color: '#16a34a', fontWeight: 500 }}>
                            Tip: {formatPrice(updatedOrder.tipAmount)} ({updatedOrder.tipPercentage}%)
                        </small>
                    }
                    <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '30% 15% 15% 20% 20%' }}>
                        <div className='grid-header' style={{ fontSize: 12, backgroundColor: '#F9FAFB' }}>
                            Product name
                        </div>
                        <div className='grid-header' style={{ fontSize: 12, backgroundColor: '#F9FAFB' }}>
                            Quantity
                        </div>
                        <div className='grid-header' style={{ fontSize: 12, backgroundColor: '#F9FAFB' }}>
                            Amount
                        </div>
                        <div className='grid-header' style={{ fontSize: 12, backgroundColor: '#F9FAFB' }}>
                            Add-ons
                        </div>
                        <div className='grid-header' style={{ fontSize: 12, backgroundColor: '#F9FAFB' }}>
                            Variants
                        </div>
                        {
                            (() => {
                                // Group identical-looking rows together for display only.
                                interface EoGroup {
                                    rep: typeof updatedOrder.products[number];
                                    qty: number;
                                    isIncluded: boolean;
                                }
                                const groups: EoGroup[] = [];
                                updatedOrder.products.forEach((p) => {
                                    const isWaived = !!(p as any).mealPlanOverride?.waived;
                                    const rawIncluded = (p as any).mealPlanStatus === 'included';
                                    const isIncluded = rawIncluded || isWaived;
                                    const matchIdx = groups.findIndex(g => {
                                        const r = g.rep;
                                        if (r.productId !== p.productId) return false;
                                        if ((r.note || '') !== (p.note || '')) return false;
                                        if ((r.addons?.length || 0) > 0 || (p.addons?.length || 0) > 0) return false;
                                        if ((r.variants?.length || 0) > 0 || (p.variants?.length || 0) > 0) return false;
                                        if ((r.discount || 0) !== (p.discount || 0)) return false;
                                        if ((r.discountType || '') !== (p.discountType || '')) return false;
                                        if (g.isIncluded !== isIncluded) return false;
                                        return true;
                                    });
                                    if (matchIdx >= 0) {
                                        groups[matchIdx].qty += p.qty || 1;
                                    } else {
                                        groups.push({ rep: p, qty: p.qty || 1, isIncluded });
                                    }
                                });
                                return groups.map((group, index) => {
                                    const prod = group.rep;
                                    const qty = group.qty;
                                    const isIncluded = group.isIncluded;
                                    const unitPrice = prod.discount && prod.discount > 0
                                        ? (prod.discountType === 'amount' ? prod.price - prod.discount : prod.price - (prod.discount / 100) * prod.price)
                                        : prod.price;
                                    return (
                                        <React.Fragment key={`eo-group-${index}`}>
                                            <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                                {prod.name}
                                                {prod.note && prod.note !== '' && (
                                                    <div style={{ fontSize: 10, color: '#667085', fontStyle: 'italic' }}>Note: {prod.note}</div>
                                                )}
                                            </div>
                                            <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                                {qty}
                                            </div>
                                            <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0', color: isIncluded ? '#027A48' : undefined }}>
                                                {isIncluded ? (
                                                    <><span style={{ fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 8, backgroundColor: '#ECFDF3', color: '#027A48', marginRight: 4 }}>MP</span>{formatPrice(0)}</>
                                                ) : formatPrice(unitPrice * qty)}
                                            </div>
                                            <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                                {prod.addons?.map(addon =>
                                                    <span style={{ fontSize: '12px', display: 'block' }}>
                                                        {addon.qty > 1 ? `${addon.qty} x ` : ''}{addon.addonName} {addon.price ? `($${addon.price})` : ''}
                                                    </span>
                                                )}
                                            </div>
                                            <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                                {prod.variants?.map(variant =>
                                                    <span style={{ fontSize: '12px', textAlign: 'end', display: 'flex' }}>
                                                        {variant.name} {variant.priceWithoutTax ? `($${variant.priceWithoutTax})` : ''}
                                                    </span>
                                                )}
                                            </div>
                                        </React.Fragment>
                                    );
                                });
                            })()
                        }

                        {
                            updatedOrder.combinations.map((comb, index) =>
                                <React.Fragment>
                                    <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                        {comb.combinationName} <br />
                                        {comb.selectedsubproductsNames && (
                                            <>
                                                {comb.selectedsubproductsNames.map((subProd, idx) => (
                                                    <span
                                                        key={idx}
                                                        style={{ fontSize: '12px', textAlign: 'end', display: 'flex' }}
                                                    >
                                                        {subProd}
                                                    </span>
                                                ))}
                                            </>
                                        )}
                                    </div>
                                    <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                        1
                                    </div>
                                    <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                        {formatPrice(comb.price)}
                                    </div>
                                    {
                                        <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                            -
                                        </div>
                                    }
                                    <div className='grid-col' style={{ fontSize: 12, backgroundColor: index % 2 == 0 ? "#fff" : "#F9FAFB", borderTop: '1px solid #EAECF0' }}>
                                        -
                                    </div>
                                </React.Fragment>
                            )
                        }
                    </div>
                    <div className='mt-3' style={{ borderTop: '1px solid #EAECF0', paddingTop: '12px' }}>
                        <div className='d-flex justify-content-between' style={{ fontSize: 13 }}>
                            <span style={{ color: '#6B7280' }}>Subtotal</span>
                            <span>{formatPrice(updatedOrder.subtotal)}</span>
                        </div>
                        {updatedOrder.tax > 0 && (
                            <div className='d-flex justify-content-between mt-1' style={{ fontSize: 13 }}>
                                <span style={{ color: '#6B7280' }}>Tax</span>
                                <span>{formatPrice(updatedOrder.tax)}</span>
                            </div>
                        )}
                        <div className='d-flex justify-content-between mt-2' style={{ fontSize: 14, fontWeight: 600, borderTop: '1px solid #EAECF0', paddingTop: '8px' }}>
                            <span>Total</span>
                            <span>
                                {formatPrice(updatedOrder.total)}
                                {(updatedOrder.tipAmount != null && updatedOrder.tipAmount > 0) && (
                                    <span style={{ fontSize: 12, fontWeight: 400, color: '#16a34a', marginLeft: '6px' }}>
                                        (+ {formatPrice(updatedOrder.tipAmount)} tip)
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                    <div className='mt-4 d-flex justify-content-end gap-3' style={{ flexWrap: 'wrap' }}>
                        {
                            isInEditMode ?
                                <>
                                    <button className='blue-outline-btn' onClick={() => { setIsInEditMode(false); setUpdatedOrder(order); }} style={{ borderRadius: 8 }}>
                                        Cancel
                                    </button>
                                    <button className='blue-filled-btn' onClick={handleSave}>
                                        Save Changes
                                    </button>
                                </>
                                :
                                <>
                                    {can('pos-app.order.edit') && <button className='blue-filled-btn' onClick={() => setIsInEditMode(true)}>
                                        Edit
                                    </button>}
                                    <button className='blue-filled-btn' onClick={printReceipt}>
                                        Print Receipt
                                    </button>
                                    {hasSplitPayments && order.payments?.filter((p: any) => p.seatId).map((payment: any, idx: number) => (
                                        <button key={payment.id || idx} className='blue-filled-btn' style={{ backgroundColor: '#6941C6', fontSize: 12 }} onClick={() => previewSplitReceipt(payment, idx + 1)}>
                                            Receipt: {payment.guestName || `Split ${idx + 1}`}
                                        </button>
                                    ))}
                                    <button className='blue-filled-btn' onClick={() => { setEmailSplitInfo(undefined); setEmailReceiptOpen(true); }}>
                                        Email Receipt
                                    </button>
                                    {can('pos-app.order.void') && <button className='blue-filled-btn' style={{ backgroundColor: '#E93225' }} onClick={handleVoidClick}>
                                        Void Order
                                    </button>}
                                </>
                        }
                    </div>
                </div>
            </div>

            <EmailReceipt isOpen={emailReceiptOpen} onBack={() => { setEmailReceiptOpen(false); setEmailSplitInfo(undefined); }} onClose={() => { setEmailReceiptOpen(false); setEmailSplitInfo(undefined); onClose() }} order={order} receiptEmailSent={() => { handleReceiptEmailSent(); setEmailSplitInfo(undefined); }} splitInfo={emailSplitInfo} />
            {isLoading && (
                <div className="spinner-container">
                    <Spinner />
                </div>
            )}
            {showSuccess && <SuccessNotification headerTitle={successTitle} content={successContent} />}
            {showError && <ErrorNotification headerTitle={errorTitle} content={errorContent} />}
            {previewHtml && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: 8,
                        width: '420px',
                        maxHeight: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                    }}>
                        <div className='d-flex justify-content-between align-items-center px-3 py-2' style={{ borderBottom: '1px solid #EAECF0' }}>
                            <strong style={{ fontSize: 14 }}>
                                {previewSplitContext ? `Split Receipt — ${previewSplitContext.payment.guestName || `Split ${previewSplitContext.splitIndex}`}` : 'Receipt Preview'}
                            </strong>
                            <button className='text-btn p-0 m-0' onClick={() => { setPreviewHtml(null); setPreviewSplitContext(null); }}>
                                <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                        <div style={{ overflowY: 'auto', flex: 1 }}>
                            <iframe
                                srcDoc={previewHtml}
                                style={{ width: '100%', height: '70vh', border: 'none' }}
                                title="Receipt Preview"
                            />
                        </div>
                        {previewSplitContext && (
                            <div className='d-flex gap-2 px-3 py-2' style={{ borderTop: '1px solid #EAECF0' }}>
                                <button className='blue-filled-btn' style={{ fontSize: 13 }} onClick={printSplitReceiptFromPreview}>
                                    Print Receipt
                                </button>
                                <button className='blue-filled-btn' style={{ fontSize: 13, backgroundColor: '#344054' }} onClick={() => {
                                    if (previewSplitContext) {
                                        setEmailSplitInfo({
                                            seatId: previewSplitContext.payment.seatId,
                                            splitIndex: previewSplitContext.splitIndex,
                                            guestName: previewSplitContext.payment.guestName || '',
                                            roomNumber: previewSplitContext.payment.roomNumber || '',
                                        });
                                    }
                                    setPreviewHtml(null);
                                    setPreviewSplitContext(null);
                                    setEmailReceiptOpen(true);
                                }}>
                                    Email Receipt
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </View>
    );
};



export default EditOrderPopup;

